import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, API, fmtGBP } from "../../api";
import { PageHeader, Panel, Btn, Input, Select, Empty, Pill } from "../../ui";

const STAGES = ["instruction", "marketing", "offer_agreed", "solicitors_instructed", "conveyancing", "exchange", "completion"];
const STAGE_LABEL = { instruction: "Instruction", marketing: "Marketing", offer_agreed: "Offer agreed", solicitors_instructed: "Solicitors instructed", conveyancing: "Conveyancing", exchange: "Exchange", completion: "Completion" };

export default function PropertiesPage() {
  const [list, setList] = useState(null);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ address: "", property_type: "Terraced", asking_price: "", agreed_price: "", stage: "instruction", solicitor_name: "" });
  const load = () => api.get(`${API}/properties`).then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post(`${API}/properties`, { address: f.address, property_type: f.property_type, asking_price: Number(f.asking_price) || null, agreed_price: Number(f.agreed_price) || null, stage: f.stage, solicitor: { name: f.solicitor_name } });
      toast.success("Property saved"); setShow(false);
      setF({ address: "", property_type: "Terraced", asking_price: "", agreed_price: "", stage: "instruction", solicitor_name: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not save"); }
  };
  const updateStage = async (id, stage) => {
    const fd = new FormData(); fd.append("stage", stage);
    await api.put(`${API}/properties/${id}/stage`, fd);
    toast.success("Stage updated"); load();
  };
  return (
    <div>
      <PageHeader title="Properties" subtitle="Sales progression stays separate from mortgage progression — both appear on the linked case." action={<Btn onClick={() => setShow(true)}>+ New property</Btn>} />
      {show && (
        <Panel className="p-6 mb-6">
          <form onSubmit={create} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="sm:col-span-2"><Input label="Address" required value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
            <Input label="Property type" value={f.property_type} onChange={(e) => setF({ ...f, property_type: e.target.value })} />
            <Select label="Stage" value={f.stage} onChange={(e) => setF({ ...f, stage: e.target.value })}>{STAGES.map(s => <option key={s} value={s}>{STAGE_LABEL[s]}</option>)}</Select>
            <Input label="Asking price (£)" type="number" value={f.asking_price} onChange={(e) => setF({ ...f, asking_price: e.target.value })} />
            <Input label="Agreed price (£)" type="number" value={f.agreed_price} onChange={(e) => setF({ ...f, agreed_price: e.target.value })} />
            <div className="sm:col-span-2"><Input label="Solicitor name" value={f.solicitor_name} onChange={(e) => setF({ ...f, solicitor_name: e.target.value })} /></div>
            <div className="sm:col-span-2 flex justify-end gap-2"><Btn variant="ghost" type="button" onClick={() => setShow(false)}>Cancel</Btn><Btn type="submit">Save</Btn></div>
          </form>
        </Panel>
      )}
      {list === null && <p className="text-sm text-slate-500">Loading…</p>}
      {list && list.length === 0 && <Empty title="No properties yet" />}
      {list && list.length > 0 && (
        <Panel>
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-200 text-[10.5px] tracking-[0.14em] uppercase text-slate-500 bg-slate-50"><th className="text-left px-5 py-3">Address</th><th className="text-left px-5 py-3">Type</th><th className="text-left px-5 py-3">Prices</th><th className="text-left px-5 py-3">Stage</th><th className="text-left px-5 py-3">Advance</th></tr></thead>
            <tbody>
              {list.map((p) => (
                <tr key={p.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-5 py-3 font-medium">{p.address}</td>
                  <td className="px-5 py-3 text-slate-600">{p.property_type || "—"}</td>
                  <td className="px-5 py-3 text-slate-600 text-[12px]">Ask {fmtGBP(p.asking_price || 0)} · Agreed {fmtGBP(p.agreed_price || 0)}</td>
                  <td className="px-5 py-3"><Pill tone="violet">{STAGE_LABEL[p.stage] || p.stage}</Pill></td>
                  <td className="px-5 py-3">
                    <select className="text-[12px] border border-slate-300 rounded px-2 py-1" value={p.stage} onChange={(e) => updateStage(p.id, e.target.value)}>
                      {STAGES.map(s => <option key={s} value={s}>{STAGE_LABEL[s]}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
